import React from "react";
import { useTranslation } from "@/translations/TranslationContext";
import expertfinancial from "@/assets/about-expertfinancial.png";

function ExpertFinancial() {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="expertfinancial mb150_75">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="expertfinancialcontent">
                <span className="chips">{t.about.mission.chips}</span>
                <h2>{t.about.mission.title}</h2>
                <p className="text24 mb38">
                  {t.about.mission.description}
                </p>
                <a className="btn btn-secondary" href="/contact">
                  {t.about.mission.button}
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                className="expertfinancialimg"
                src={expertfinancial}
                alt="expertfinancial"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExpertFinancial;
